import {BiX} from "react-icons/bi";
import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";

const MSTreeSelectedCtrl =  forwardRef( (props, ref) => {
    useImperativeHandle(ref, () => {
        return {
            setSelectedNodes: setSelected
        };
    })

    const labelKey = props.labelKey ? props.labelKey : 'ConcatName';
    const [selectedData, setSelectedDataState] = useState([]);
    const setSelected = (selectedData) => {
        //console.log('selectedData', selectedData)
        setSelectedDataState(selectedData);
    }


    const onRemoveSelectedItem = (item, index) => {
        //  console.log('Onremove called CHILD',  item, index);
        if (index > -1) {
            selectedData.splice(index, 1);
        }
        props.selectedItemsRemoved(selectedData)
    }
    return (
        <div>
            {/* <h1>Selected items  = {selectedData.length}</h1>*/}
            <div className={'dts-selected-items-container'} >
                {selectedData && selectedData.length? selectedData.map((item, index) => (<span key={index} className={'dts-selected-item'}>{item[labelKey]} <span onClick={() =>  onRemoveSelectedItem(item, index)}><BiX  className={'dts-remove-btn'}></BiX> </span> </span>)) : ''}
            </div>
        </div>
    );
})

export default MSTreeSelectedCtrl;